import { call } from 'redux-saga/effects'
import { localisedError } from '../../../utilities/Errors'
import getCurrentUid from '../../../utilities/getCurrentUid'
import that from '../../../utilities/translationHelper'
import { functions } from '../../../utilities/firebase'

export function getParamsForNotificationsByUid() {
	return { uid: getCurrentUid() }
}

export function getParamsForMoreNotificationsByUid(params) {
	return { uid: getCurrentUid(), startAfterTimestamp: params.startAfterTimestamp }
}

export function getParamsForNotificationsSeenSet(params) {
	return { notificationIds: params.notifications.map(notification => notification.notificationId) }
}

export function* notificationsSeen({ notificationIds }) {
	const { data: result } = yield call(functions.httpsCallable('notificationsSeen'), { notificationIds })
	if (!result.success) {
		throw localisedError(that.context.translate('Could not update notifications'), result)
	}
}



// WEBPACK FOOTER //
// ./src/redux/saga/notifications/sagas.js